import { render, staticRenderFns } from "./MotoboyPresenceSidebar.vue?vue&type=template&id=2562a40a&scoped=true&"
import script from "./MotoboyPresenceSidebar.vue?vue&type=script&lang=js&"
export * from "./MotoboyPresenceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MotoboyPresenceSidebar.vue?vue&type=style&index=0&id=2562a40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2562a40a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2562a40a')) {
      api.createRecord('2562a40a', component.options)
    } else {
      api.reload('2562a40a', component.options)
    }
    module.hot.accept("./MotoboyPresenceSidebar.vue?vue&type=template&id=2562a40a&scoped=true&", function () {
      api.rerender('2562a40a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/MotoboyPresenceSidebar.vue"
export default component.exports